import { Button, IconGearSix, Stack, Text } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useDrawerSubForm } from 'hooks'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import {
  CancelButton,
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  SaveButton,
  UseDrawerStateReturn,
} from 'ui'
import { MoreForLessBenefit } from '../../../../../../typings'
import { Distributed } from './Distributed'
import { Equals } from './Equals'
import { messages } from './messages'
import { MostExpensive } from './MostExpensive'
import styles from './styles.css'

type Props = {
  form: FormState
  onSave: (config: MoreForLessBenefit['apply']) => void
  drawerState: UseDrawerStateReturn
}

export function AdvancedConfig(props: Props) {
  const { form, onSave, drawerState } = props
  const { $t } = useIntl()

  const apply = useWatch({ form, name: 'benefit.apply' })
  const triggerMinQuantity: number = useWatch({
    form,
    name: 'trigger.minQuantity',
  })
  const benefitQuantity: number = useWatch({ form, name: 'benefit.quantity' })

  /**
   * Update the values to string from bool to avoid issues with the form
   */
  const mappedApply = useMemo(
    () =>
      Object.fromEntries(Object.entries(apply).map(([k, v]) => [k, String(v)])),
    [apply]
  )
  /**
   * Update the values to bool from string to save
   */
  const convertToSave = (values) =>
    Object.fromEntries(
      Object.entries(values).map(([k, v]) => [k, v === 'true'])
    )

  const { drawerForm } = useDrawerSubForm({
    config: mappedApply,
    isOpen: drawerState.open,
  })

  const handleSave = async () => {
    const newValues = convertToSave(
      drawerForm.getValues()
    ) as MoreForLessBenefit['apply']

    onSave(newValues)

    drawerState.hide()
  }
  return (
    <>
      <Button
        icon={<IconGearSix />}
        onClick={drawerState.show}
        variant="tertiary"
        className={styles.button}
      >
        {$t(messages.title)}
      </Button>
      <Drawer state={drawerState} level={1}>
        <DrawerHeader>
          <DrawerTitle>{$t(messages.title)}</DrawerTitle>
          <DismissButton onHide={drawerState.hide} />
        </DrawerHeader>
        <DrawerContent>
          <Stack space="$space-6">
            <Text variant="title2">{$t(messages.description)}</Text>
            <Equals state={drawerForm} />
            <MostExpensive state={drawerForm} />
            <Distributed
              state={drawerForm}
              minQuantity={triggerMinQuantity}
              quantity={benefitQuantity}
            />
          </Stack>
        </DrawerContent>
        <DrawerFooter>
          <CancelButton onClick={drawerState.hide} />
          <SaveButton onClick={handleSave} />
        </DrawerFooter>
      </Drawer>
    </>
  )
}
